export default __webpack_public_path__ + "images/2W.14df35f.png";